import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

const KISSES_FORM_NAME = 'KissesModal'

const KissessFormModal = Loadable(() => import('./CollateralManagementForm'))

export const createKissesNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'route',
  text: translateFn('mnu_collateral_management'),
  identity: KISSES_FORM_NAME,
  permission: ['VIEW_COLLATERAL', 'VIEW_USER_REPORTS', 'COLLATERAL_MANAGEMENT'],
  component: KissessFormModal,
}))
